/**
 * Accounts screens' route paths more than one file depends on: `./routes.ts`
 * registers them.
 *
 * The list keeps `ACCOUNTS_PATH` and `accountsPath` where they already live,
 * `../../control/paths.ts`, rather than redeclaring them here: `./routes.ts`
 * mounts the "Contas monitoradas" frame (105:6) at that URL, and files outside
 * this area (`tenant/home/TenantHome.tsx`, `tenant/home/CampaignCards.tsx`,
 * `data/first-data/FirstDataView.tsx`) link
 * into it. Redeclaring it here would be a second definition of one route to
 * drift from the first.
 *
 * The open account (frame 75:2 / 299:10749) is a different, additive
 * capability from `../../control/paths.ts`'s `TRACKING_EDITOR_PATH` -- a read
 * overview with a rename control, not the choice of collection profile -- so
 * it coexists at its own path below.
 *
 * Relative to the router's `basepath`, like every other route literal in
 * this plane.
 */

import { interpolatePath } from '@tanstack/react-router';

export const ACCOUNT_PATH = '/c/$campaignId/accounts/$accountId';

/** The Conta entry's own page with no account chosen yet: its picker. A static
 *  segment, so it outranks `$accountId` for this one literal. */
export const ACCOUNT_SELECT_PATH = '/c/$campaignId/accounts/conta';

/** `ACCOUNT_PATH` filled in, for a caller outside this area. */
export function accountPath(campaignId: string, accountId: string): string {
  return interpolatePath({ path: ACCOUNT_PATH, params: { campaignId, accountId } })
    .interpolatedPath;
}
